import { Link } from "@/components/common/Link";
import { Instagram, Video, ShieldCheck, Lock, CreditCard } from "lucide-react";
const quickLinks = [{
  label: "Articles",
  href: "/ArticlesPage"
}, {
  label: "About PDA",
  href: "/AboutSupportPage"
}, {
  label: "Shop",
  href: "/ShopPage"
}];
const socialLinks = [{
  icon: Instagram,
  label: "Instagram",
  href: "#"
}, {
  icon: Video,
  label: "TikTok",
  href: "#"
}];
export default function Footer() {
  return <section data-section-id="159790" id="footer-navigation" className="bg-primary text-primary-foreground py-12 md:py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 lg:gap-12">
          
          {}
          <div className="flex flex-col items-start justify-start">
            <Link to="/HomePage" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559791/img/scrubmagic_logo_light.png" alt="PDA Australia Logo" className="h-7 w-auto object-contain" />
            </Link>
          </div>

          {}
          <div className="flex flex-col items-start md:items-center">
            <h3 className="text-sm font-serif font-bold tracking-wider uppercase text-primary-foreground/70 mb-4">
              Explore
            </h3>
            <ul className="space-y-3 flex flex-col items-start md:items-center">
              {quickLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-primary-foreground/90 hover:text-primary-foreground transition-colors text-sm font-sans">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col items-start md:items-end">
            <h3 className="text-sm font-serif font-bold tracking-wider uppercase text-primary-foreground/70 mb-4">
              Get Support
            </h3>
            <div className="flex gap-4 mb-8">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} className="text-primary-foreground/90 hover:text-primary-foreground transition-colors p-2 -m-2" aria-label={social.label}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>

            <div className="flex flex-col items-start md:items-end">
              <p className="text-xs text-primary-foreground/70 mb-3 uppercase tracking-wider font-serif font-bold">
                Privacy & Legal
              </p>
              <div className="flex gap-3 items-center text-primary-foreground/90">
                <ShieldCheck className="size-6" strokeWidth={1.5} />
                <Lock className="size-6" strokeWidth={1.5} />
                <CreditCard className="size-6" strokeWidth={1.5} />
              </div>
            </div>
          </div>

        </div>

        {}
        <div className="mt-12 pt-8 border-t border-primary-foreground/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-primary-foreground/60 text-center md:text-left font-sans">
            &copy; {new Date().getFullYear()} PDA Australia. All rights reserved.
          </p>
        </div>
      </div>
    </section>;
}